<template>
  <div class="main-content">
    <div>
      <!-- {{ selected }} -->
      <v-card class="pl-3 pr-3 fs-card-topbar" outlined shaped tile>
        <v-row class="mt-3 mb-n3" no-gutters>
          <v-col md="8">
            <v-form autocomplete="off">
              <v-row no-gutters>
                <v-text-field
                  @keydown.enter.prevent="pesquisar()"
                  style="border-top-left-radius: 15px; width: 325px; max-width: 325px"
                  class="fs-searchfield"
                  label="Pesquisar"
                  placeholder=" "
                  spellcheck="false"
                  v-model="textoPesquisa"
                  append-icon="mdi-magnify"
                  @click:append="pesquisar()"
                  outlined
                  dense
                />
                <v-btn
                  @click="dialogFiltros = true"
                  class="fs-btns-crud-grid"
                  style="margin-top: 2px"
                  height="32px"
                  outlined
                  small
                >
                  <v-icon class="mr-1">mdi-filter</v-icon>
                  Selecionar Filtros
                </v-btn>
                <v-btn v-if="filtroComposto.length > 1" @click="limparFiltros()" class="fs-btns-crud-grid" style="margin-top: 2px" height="32px" color="error" outlined small>
                  <v-icon class="mr-1">mdi-filter-remove-outline</v-icon>
                  Limpar Filtros
                </v-btn>
                <v-btn @click="exportarExcel()" class="fs-btns-crud-grid" style="margin-top: 2px" height="32px" color="primary" outlined small>
                  <v-icon class="mr-1">mdi-file-excel</v-icon>
                  Exp. p/ Excel
                </v-btn>
              </v-row>
            </v-form>
          </v-col>
          <v-spacer></v-spacer>
          <div class="fs-topbar-right">
          </div>
        </v-row>
      </v-card>

      <v-dialog width="400px" v-model="dialogExcel">
        <v-card>
          <v-card-title>
            Seu arquivo está pronto!
          </v-card-title>
          <v-card-text>
            Faça o download clicando no botão abaixo.
          </v-card-text>
          <v-divider class="ma-0 "/>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#2A2F50" download="report.csv" :href="linkExcel" @click="dialogExcel = false" dark small>
              <v-icon class="mr-1" style="font-size: 15px !important">mdi-download</v-icon>
              Fazer Download
            </v-btn>
            <v-btn color="warning" @click="dialogExcel = false" dark small>
              <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogFiltros" width="450px">
        <v-card>
          <v-btn @click="dialogFiltros = false" style="position: absolute; right: 0; top: 0" icon>
            <v-icon style="font-size: 25px !important">mdi-close</v-icon>
          </v-btn>
          <v-form autocomplete="off">
            <v-card-title>Filtros Específicos</v-card-title>
            <v-divider class="mt-n1 mb-n3"/>
            <v-card-text>
              <v-row class="px-2 pb-1 fs-div-checkbox-filtro" no-gutters>
                <v-col md="12">
                  <div class="mb-4">
                    <label class="fs-label-filtro">Intervalo de Datas</label>
                  </div>
                </v-col>
                <v-col md="5">
                  <v-menu
                    v-model="menuDataInicialFiltro"
                    :close-on-content-click="false"
                    :nudge-top="48"
                    :nudge-right="10"
                    transition="scale-transition"
                    max-width="290"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        class="mb-n5 mr-1"
                        :value="formatDataInicial"
                        append-outer-icon="mdi-calendar"
                        label="Data Inicial"
                        placeholder=" "
                        @click:clear="dataInicial = null"
                        v-on="on"
                        outlined
                        readonly
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dataInicial"
                      @change="menuDataInicialFiltro = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col md="5">
                  <v-menu
                    v-model="menuDataFinalFiltro"
                    :close-on-content-click="false"
                    :nudge-top="48"
                    :nudge-right="10"
                    transition="scale-transition"
                    max-width="290"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        class="mb-n5 ml-1"
                        :value="formatDataFinal"
                        append-outer-icon="mdi-calendar"
                        label="Data Final"
                        placeholder=" "
                        @click:clear="dataFinal = null"
                        v-on="on"
                        outlined
                        readonly
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dataFinal"
                      @change="menuDataFinalFiltro = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col md="2">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-switch
                        v-model="filtroData"
                        v-on="on"
                        class="mt-0 ml-5"
                        color="#2A2F50"
                        :value="true"
                        hide-details
                      ></v-switch>
                    </template>
                    <span style="font-size: 11px">
                      {{ filtroData ? 'FILTRO POR DATA ATIVADO' : 'FILTRO POR DATA DESATIVADO' }}
                    </span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <div class="fs-div-checkbox-filtro">
                <v-row no-gutters>
                  <v-col>
                    <label class="fs-label-filtro">Status da Arte</label>
                    <v-select
                      class="mr-1 mt-3 mb-2"
                      label="Status"
                      v-model="filtros.status_arte"
                      item-text="text"
                      item-value="value"
                      height="32px"
                      :items="opcoesFiltro"
                      hide-details
                      placeholder=" "
                      outlined
                      dense
                    />
                  </v-col>
                  <v-col>
                    <label class="fs-label-filtro">Listar Artes Canceladas</label>
                    <v-select
                      class="ml-1 mt-3 mb-2"
                      label="Listar"
                      v-model="filtros.cancelados"
                      item-text="text"
                      item-value="value"
                      height="32px"
                      :items="[{value: 'S', text: 'Sim'}, {value: 'N', text: 'Não'}]"
                      hide-details
                      placeholder=" "
                      outlined
                      dense
                    />
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="filtros = {}" class="fs-btns-crud-grid" style="margin-top: 2px" height="32px" color="warning" small>
                <v-icon class="mr-1">mdi-close</v-icon>
                Resetar Campos
              </v-btn>
              <v-btn @click="atualizarFiltros()" class="fs-btns-crud-grid" style="margin-top: 2px" height="32px" color="primary" small>
                <v-icon class="mr-1">mdi-refresh</v-icon>
                Atualizar Filtros
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <v-card class="mt-2" outlined tile>
        <v-data-table
          height="405px"
          :loading="loading"
          loading-text="Carregando, aguarde..."
          :headers="headers"
          :items="artes.data"
          :items-per-page="9999999"
          hide-default-footer
          hide-action
          item-key="id"
        >
          <template v-slot:body="{ items }">
            <tr
              id="fs-row"
              :class="row === selected ? 'fs-row-selected' : ''"
              v-for="(row, index) in items"
              :key="index"
            >
              <td width="100px" @click="setArteSelecionada(row)">{{ row.pedido_externo_empresa }}</td>
              <td width="70px" @click="setArteSelecionada(row)">{{ row.id }}</td>
              <td @click="setArteSelecionada(row)">{{ formatarDataHora(row.created_at, 'DD/MM/YYYY') }}</td>
              <td width="130px" @click="setArteSelecionada(row)">{{ formatarDataHora(row.updated_at, 'DD/MM/YYYY HH:mm') }}</td>
              <td width="110px" @click="setArteSelecionada(row)">{{ row.numero_pedido }}</td>
              <!-- <td width="100px" @click="setArteSelecionada(row)">{{ row.item.ecommerce_carrinho_id }}</td>
              <td @click="setArteSelecionada(row)">{{ row.item.descricao }}</td>  -->
              <!-- Conteúdo a ser mostrado se row.item existir -->
              <td v-if="row.item" width="100px" @click="setArteSelecionada(row)">
                {{ row.item.ecommerce_carrinho_id }}
              </td>
              <td v-else width="100px" @click="setArteSelecionada(row)">
                Outro CRM
              </td>
              <td @click="setArteSelecionada(row)">{{ row.produto }}</td>
              <td @click="setArteSelecionada(row)">{{ row.razao_social }}</td>
              <td width="150px" @click="setArteSelecionada(row)">{{ row.cnpj | formatarCNPJ }}</td>
              <td width="140px" @click="setArteSelecionada(row)">{{ row.nome_arte }}</td>
              <td width="120px" @click="setArteSelecionada(row)">{{ formatarMoeda(row.valor_total_pedido, 2) }}</td>
              <td @click="setArteSelecionada(row)">{{ row.qtde_cores_crm + ' / ' + row.qtde_cores_erp }}</td>
              <td width="50px" @click="setArteSelecionada(row)">
                <v-chip v-if="row.status_arte === '0'" color="white" class="fs-chip" small>Pendente</v-chip>
                <v-chip
                  v-else-if="row.status_arte === '1'"
                  color="error"
                  class="fs-chip"
                  small
                >Enviado p/ Aprovação do Cliente</v-chip>
                <v-chip
                  v-else-if="row.status_arte === '2'"
                  color="primary"
                  class="fs-chip"
                  small
                >Aprovado pelo Cliente</v-chip>
                <v-chip
                  v-else-if="row.status_arte === '3'"
                  color="warning"
                  class="fs-chip"
                  small
                >Reprovado pelo Cliente</v-chip>
                <v-chip
                  v-else-if="row.status_arte === '4'"
                  color="success"
                  class="fs-chip"
                  small
                >Processo Finalizado</v-chip>
                <v-chip
                  v-else-if="row.status_arte === '5'"
                  color="black"
                  dark
                  class="fs-chip"
                  small
                >Cancelado</v-chip>
              </td>
              <td width="30px">
                <v-menu ref="menuOpcoes" offset-y :nudge-top="68" :nudge-left="40" left>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                      <v-icon>mdi-menu</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="visualizarPedido(row)">
                      Visualizar Pedido
                    </v-list-item>
                    <v-list-item v-if="row.status_arte !== '4' && row.status_arte !== '5'">
                      <v-menu
                        offset-y
                        open-on-hover
                        :nudge-top="60"
                        :nudge-left="79"
                        :close-on-content-click="false"
                        left
                      >
                        <template v-slot:activator="{ on }">
                          <a v-on="on" @click.stop>Alterar Status</a>
                        </template>
                        <v-list>
                          <v-list-item @click="alterarStatus('0', index, row)">
                            <a>Pendente</a>
                          </v-list-item>
                          <v-list-item @click="alterarStatus('1', index, row)">
                            <a>Enviado p/ Aprovação do Cliente</a>
                          </v-list-item>
                          <v-list-item @click="alterarStatus('2', index, row)">
                            <a>Aprovado pelo Cliente</a>
                          </v-list-item>
                          <v-list-item @click="alterarStatus('3', index, row)">
                            <a>Reprovado pelo Cliente</a>
                          </v-list-item>
                          <v-list-item @click="finalizarProcesso('4', index, row)">
                            <a>Processo Finalizado</a>
                          </v-list-item>
                          <v-list-item @click="cancelarProcesso('5', index, row)">
                            <a>Cancelado</a>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
        </v-data-table>

        <v-row
          class="pl-4 pr-6 py-3"
          style="background-color: white"
          no-gutters
        >
          <v-col cols="12">
            <v-row align="center" justify="space-between">
              <v-card class="ml-3" flat>
                <v-btn-toggle v-model="limit" mandatory group dense>
                  <!-- <v-btn :value="3" class="fs-btn-limit">3</v-btn> -->
                  <v-btn :value="10" class="fs-btn-limit">10</v-btn>
                  <v-btn :value="20" class="fs-btn-limit">20</v-btn>
                  <v-btn :value="30" class="fs-btn-limit">30</v-btn>
                  <v-btn :value="50" class="fs-btn-limit">50</v-btn>
                  <v-btn :value="100" class="fs-btn-limit">100</v-btn>
                  <div
                    v-if="artes.data"
                    style="background-color: #EEEEEE; padding: 10px; margin: 5px; color: gray; font-size: 11px; letter-spacing: 1px"
                  >{{ artes.total }} REGISTROS</div>
                </v-btn-toggle>
              </v-card>
              <v-card flat>
                <v-pagination
                  color="#2A2F50"
                  v-model="page"
                  :length="artes.lastPage"
                  circle
                  total-visible="8"
                ></v-pagination>
              </v-card>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </div>

    <v-dialog v-model="dialogDetalhes" max-width="1000px">
      <detalhespedido v-if="dialogDetalhes" :itemMostrarDetalhes="pedidoArteSelecionada" :fecharDetalhes="fecharDetalhes"></detalhespedido>
    </v-dialog>

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import * as api from '@/api/crud' // eslint-disable-line
import { apiFinalizarProcesso, apiCancelarProcesso, apiExcelArtesPersonalizadas } from '@/api/controledeartes'

import moment from 'moment'

export default {
  components: {
    detalhespedido: () => import('@/views/app/crm/listagemdepedidos/tablepedidos/dialogdetalhes')
  },
  filters: {
    formatarCNPJ (cnpj) {
      if (cnpj === null) {
        return ''
      }
      let mascara = cnpj.replace(/\D/g, '')
      if (mascara.length <= 14) {
        mascara = mascara.replace(/^(\d{2})(\d)/, '$1.$2')
        mascara = mascara.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        mascara = mascara.replace(/\.(\d{3})(\d)/, '.$1/$2')
        mascara = mascara.replace(/(\d{4})(\d)/, '$1-$2')
      }
      return mascara
    }
  },
  data () {
    return {
      headers: [
        { text: 'EMPRESA', value: 'pedido_externo_empresa' },
        { text: 'ID', value: 'id' },
        { text: 'DATA', value: 'created_at' },
        { text: 'ULT ATUALIZ.', value: 'updated_at' },
        // { text: 'DT. PEDIDO', value: 'dt_pedido_erp' },
        { text: 'N° PED(ERP)', value: 'numero_pedido' },
        { text: 'CARRINHO', value: 'numero_pedido_crm' },
        { text: 'PRODUTO', sortable: false },
        { text: 'CLIENTE', value: 'razao_social' },
        { text: 'CNPJ', value: 'cnpj' },
        { text: 'NOME ARTE', value: 'nome_arte' },
        { text: 'VALOR TOTAL', value: 'valor_total_pedido' },
        { text: 'CORES CRM/ERP', value: 'qtde_cores_crm', sortable: false },
        // { text: 'SITUAÇÃO INTERNA', value: 'situacao_interna' },
        { text: 'STATUS', value: 'status_arte' },
        { text: '' }
      ],
      opcoesFiltro: [
        { value: '0', text: 'Pendente' },
        { value: '1', text: 'Enviado p/ Aprovação do Cliente' },
        { value: '2', text: 'Aprovado pelo Cliente' },
        { value: '3', text: 'Reprovado pelo Cliente' },
        { value: '4', text: 'Processo Finalizado' },
        { value: '5', text: 'Cancelado' },
        { value: '', text: 'Todos' }
      ],
      dataInicial: moment().startOf('month').format('YYYY-MM-DD'),
      dataFinal: moment().endOf('month').format('YYYY-MM-DD'),
      menuDataFinal: false,
      menuDataFinalFiltro: false,
      menuDataInicial: false,
      menuDataInicialFiltro: false,
      filtros: {
        cancelados: 'N'
      },
      dialogDetalhes: false,
      pedidoArteSelecionada: null,
      filtroComposto: [],
      filtroData: false,
      selected: {},
      dialog: false,
      dialogFiltros: false,
      dialogExcel: false,
      linkExcel: null,
      textoPesquisa: '',
      artes: [],
      loading: true,
      limit: 10,
      page: 1
    }
  },
  watch: {
    page: function () {
      this.filtrar()
    },
    limit: function () {
      this.page = 1
      this.filtrar()
    }
  },
  computed: {
    ...mapGetters('authData', ['loggedInUser']),
    ...mapState({
      confirm: state => state.global.confirm
    }),
    formatDataInicial () {
      return this.dataInicial ? moment(this.dataInicial).format('DD/MM/YYYY') : ''
    },
    formatDataFinal () {
      return this.dataFinal ? moment(this.dataFinal).format('DD/MM/YYYY') : ''
    }
  },
  mounted () {
    this.filtrar()
  },
  methods: {
    ...mapMutations({
      setSnackbar: 'global/setSnackbar',
      SETARTESELECIONADA: 'controledeartes/SETARTESELECIONADA'
    }),
    ...mapActions({
      getPedido: 'pedidos/getPedido'
    }),
    async exportarExcel () {
      this.loading = true
      setTimeout(async () => {
        this.montarFiltroComposto()
        const csvString = await apiExcelArtesPersonalizadas(this.querySerialize('filtro', this.filtroComposto))
        const universalBOM = '\uFEFF'
        this.linkExcel = 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + csvString)
        this.loading = false
        this.dialogExcel = true
        this.downloadExcel = true
      }, 700)
    },
    limparFiltros () {
      this.setArteSelecionada(null)
      this.page = 1
      this.filtros = {}
      this.filtroData = false
      this.filtrar()
    },
    filtrarStatus () {
      this.filtrar()
    },
    async finalizarProcesso (status, index, item) {
      this.$refs.menuOpcoes[index].isActive = false
      this.loading = true
      if (await this.confirm.open('Finalizar Processo', 'Tem certeza que deseja continuar?', { color: 'error' })) {
        try {
          const res = await apiFinalizarProcesso(item)
          if (res.error) {
            this.setSnackbar({ msg: `Ocorreu um erro! ${res.error}`, color: 'error' })
          } else {
            this.setSnackbar({ msg: 'Status atualizado com sucesso!', color: 'green' })
            item.status_arte = status
            item.situacao_interna = '1'
          }
        } catch (error) {
          this.setSnackbar({ msg: `Ocorreu um erro! ${error.message}`, color: 'error' })
        }
      }
      this.loading = false
    },
    async cancelarProcesso (status, index, item) {
      this.$refs.menuOpcoes[index].isActive = false
      this.loading = true
      if (await this.confirm.open('Cancelar Processo', 'Tem certeza que deseja continuar?', { color: 'error' })) {
        try {
          await apiCancelarProcesso(item)
          item.status_arte = status
          item.situacao_interna = '2'
          this.setSnackbar({ msg: 'Status atualizado com sucesso!', color: 'green' })
        } catch (error) {
          this.setSnackbar({ msg: error, color: 'red' })
        }
      }
      this.loading = false
    },
    async pesquisar () {
      this.setArteSelecionada(null)
      this.filtros = {}
      this.loading = true
      const paginate = {
        page: this.page,
        limit: this.limit
      }
      const pesquisa = []
      if (this.textoPesquisa.length) {
        pesquisa.push({ field: 'todos', value: this.textoPesquisa }, { field: 'tipo', value: '1' })
        this.artes = await api.list2('/crm/controleartesfiltro', { tipo: 'pesquisa', query: this.serializePesquisa('pesquisa', pesquisa) }, paginate)
        this.loading = false
      } else {
        this.setArteSelecionada(null)
        this.page = 1
        this.filtros = { cancelados: 'N' }
        this.filtroData = false
        this.filtrar()
      }
    },
    fecharDetalhes () {
      this.dialogDetalhes = false
    },
    async visualizarPedido (arte) {
      try {
        if ((arte.item === null) || (arte.item === undefined) || (arte.item === '')) {
          this.setSnackbar({ msg: 'Não existe um PEDIDO vinculado a esta Arte, pode ser um pedido externo, verifique!', color: 'red' })
          return
        }
        this.pedidoArteSelecionada = (await this.getPedido(arte.item.ecommerce_carrinho_id))[0]
        this.dialogDetalhes = true
      } catch (error) {
        this.setSnackbar({ msg: `Ocorreu um erro! ${error}` })
      }
    },
    async alterarStatus (status, index, item) {
      this.$refs.menuOpcoes[index].isActive = false
      if (item.status_arte === '4') {
        this.setSnackbar({ msg: 'Esse processo está finalizado, portanto não é possível alterar.', color: 'red' })
      } else {
        const obj = {
          id: item.id,
          status_arte: status
        }
        try {
          await api.edit('/crm/controleartes', 'edit', item.id, obj)
          item.status_arte = status
          this.setSnackbar({ msg: 'Status atualizado com sucesso!', color: 'green' })
        } catch (error) {
          this.setSnackbar({ msg: error, color: 'red' })
        }
      }
    },
    setArteSelecionada (row) {
      this.selected = row
      this.SETARTESELECIONADA(row)
    },
    atualizarFiltros () {
      this.page = 1
      this.dialogFiltros = false
      this.filtrar()
    },
    async filtrar () {
      this.setArteSelecionada(null)
      this.filtros.tipo = '1'
      this.loading = true
      this.montarFiltroComposto()
      const paginate = {
        page: this.page,
        limit: this.limit
      }
      const obj = {
        tipo: 'filtro',
        query: this.querySerialize('filtro', this.filtroComposto)
      }
      this.artes = await api.list2('/crm/controleartesfiltro', obj, paginate)
      this.loading = false
    },
    formatarDataHora (data, format) {
      return moment(data).format(format)
    },
    formatarMoeda (number, digits) {
      number = parseFloat(number).toFixed(digits)
      number = number.toString()
      var pattern = /(-?\d+)(\d{3})/
      while (pattern.test(number)) { number = number.replace(pattern, '$1,$2') }
      return 'R$ ' + number
    },
    async montarFiltroComposto () {
      this.filtroComposto = []
      const keys = Object.keys(this.filtros)
      for (let i = 0; i < keys.length; i++) {
        if (!this.filtros[keys[i]] || this.filtros[keys[i]] === '') { continue }
        if (typeof this.filtros[keys[i]] === 'object' && !this.filtros[keys[i]].length) { continue }
        if (this.filtros[keys[i]]) {
          const type = this.filtros[keys[i]].length ? typeof this.filtros[keys[i]][0] : typeof this.filtros[keys[i]]
          this.filtroComposto.push({ field: keys[i], value: this.filtros[keys[i]], type })
        }
      }
      if (this.filtroData) {
        this.filtroComposto.push({ field: 'dataInicial', value: this.dataInicial + ' 00:00:00' })
        this.filtroComposto.push({ field: 'dataFinal', value: this.dataFinal + ' 23:59:59' })
      }
    },
    querySerialize (nome, filtro) {
      let query = ''
      for (let i = 0; i < filtro.length; i++) {
        if (i === 0) query = query + nome
        query = query + encodeURIComponent(`[${i}]`) + '=' + encodeURIComponent(JSON.stringify(filtro[i]))
        if (i < filtro.length - 1) query = query + `&${nome}`
      }
      query = query.replace(/%2C/g, ',')
      return query
    },
    serializePesquisa (nome, filtro) {
      let query = ''
      for (let i = 0; i < filtro.length; i++) {
        if (i === 0) {
          query = query + nome + '%5B0%5D' + '=' + '%5B' + encodeURIComponent(JSON.stringify(filtro[i]))
        } else {
          query = query + encodeURIComponent(',') + encodeURIComponent(JSON.stringify(filtro[i]))
        }
      }
      return query + '%5D'
    }
  }
}
</script>

<style scoped>
#fs-row:hover {
  background-color: rgba(236, 236, 236, 0.603);
}
.fs-row-selected {
  background-color: rgb(255, 239, 239) !important;
}
.fs-btns-top:active,
.fs-btns-top:focus {
  border: 1px solid rgb(122, 122, 122) !important;
}
.fs-searchfield .v-input__icon--append .v-icon {
  margin-top: -6px;
  font-size: 23px !important;
}
.fs-searchfield .v-input__icon--append .v-icon:hover {
  color: black;
}
.fs-btn-limit {
  font-size: 11px !important;
}
.v-input--selection-controls.v-input .v-label {
  padding-top: 9px !important;
  font-size: 12px !important;
}
.fs-topbar-crud {
  text-align: right;
  margin-top: -3px;
}
.fs-btns-crud-grid {
  padding: 3px 7px 3px 7px !important;
  margin-left: 10px;
}
.fs-btns-crud-grid:active {
  border: 1px solid rgb(122, 122, 122) !important;
}
.fs-card-topbar {
  height: 62px;
  border-bottom-right-radius: 0px;
}
.fs-checkbox-filtros {
  padding-top: 0px !important;
  margin-left: -5px !important;
  margin-top: -5px !important;
  height: 30px !important;
}
.fs-div-checkbox-filtro {
  background-color: #F8F8F8;
  border: 1px solid #CCC;
  border-radius: 4px;
  padding: 5px 10px 2px 10px;
  margin-top: 10px;
  text-align: center;
  border-radius: 4px;
}
</style>
